import { WarehouseElementData } from "components/WarehouseElements/WarehouseElements";
import { TestIds } from "constants/Tests/TestIds";
import { JSX } from "react";
import GridElement from "./GridElement";

const createGridElements = (
  gridElements: WarehouseElementData[]
): JSX.Element[] => {
  return gridElements.map(gridElement => (
    <GridElement
      data-testid={TestIds.INTERACTIVE}
      key={gridElement.id}
      type={gridElement.type}
      id={gridElement.id}
      etiquette={gridElement.etiquette}
      gridElementLocationSpan={gridElement.gridElementLocationSpan}
    />
  ));
};

export default createGridElements;
